import { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { IconLink } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModalCloseButton = (props: Props) => {
  const { accessibilityLabel, palette = 'muted', withBottomMargin, onPress } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const buttonStyles = [
    styles.button,
    withBottomMargin ? styles.buttonWithBottomMargin : undefined,
  ];

  return (
    <IconLink
      name="IconClose"
      width={40}
      height={40}
      palette={palette}
      accessibilityLabel={accessibilityLabel}
      style={buttonStyles}
      onPress={onPress}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    alignSelf: 'flex-end',
  },
  buttonWithBottomMargin: {
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  accessibilityLabel: string;
  palette?: ComponentProps<typeof IconLink>['palette'];
  withBottomMargin?: boolean;
  onPress: () => void;
};
